// this is search query parameter key to get the redirect URL 
export const REDIRECT_URL = "redirectUrl";
// this is search query parameter key to get the error message
export const ERROR_MSG_QUERY_KEY = "error";
const queryParams = new URLSearchParams(window.location.search);
const redirectURL = queryParams.get(REDIRECT_URL);

const dh_family_urls = process.env.REACT_APP_DH_FAMILY_URLS.split(",");
export const DECCAN_URL = dh_family_urls?.find(url => redirectURL?.toLowerCase()?.includes(url)) || "deccanherald";

const prajavani_urls = process.env.REACT_APP_PRAJAVANI_FAMILY_URLS?.split(",");
export const PRAJAVANI_URL = prajavani_urls?.find(url => redirectURL?.toLowerCase()?.includes(url)) || "prajavani";

export const INFO_MSG_EMAIL = "Please check your email for OTP";
export const INFO_MSG_PHONE = "Please check your phone for OTP";
export const PRAJAVANI_REDIRECT_URLS = (
  process.env.REACT_APP_PV_REDIRECT_URLS || ""
).split(",");
export const DECCAN_REDIRECT_URLS = (
  process.env.REACT_APP_DH_REDIRECT_URLS || ""
).split(",");
export const DEFAULT_REDIRECT_URL = DECCAN_REDIRECT_URLS[0] || "";
export const DECCAN_TERMS_URL =
  process.env.REACT_APP_DH_TERMS || DECCAN_REDIRECT_URLS[0] + "/terms";
export const DECCAN_PRIVACY_POLICY_URL =
  process.env.REACT_APP_DH_PRIVACY_POLICY ||
  DECCAN_REDIRECT_URLS[0] + "/privacy-policy";
export const PRAJAVANI_TERMS_URL =
  process.env.REACT_APP_PV_TERMS || PRAJAVANI_REDIRECT_URLS[0] + "/terms";
export const PRAJAVANI_PRIVACY_POLICY_URL =
  process.env.REACT_APP_PV_PRIVACY_POLICY ||
  PRAJAVANI_REDIRECT_URLS[0] + "/privacy-policy";

export const GENERAL_ERROR_MSG = "Oops! Something went wrong.";
export const DECCAN_MOBILE_TAB = "Mobile";
export const PRAJAVANI_MOBILE_TAB = "ಮೊಬೈಲ್";
export const PRAJAVANI_EMAIL_TAB = "ಇಮೇಲ್";
// identifier name  constants of tab common between both apps (deccan and prajavani both)
export const email_tab_indetifier = "email";
export const mobile_tab_indetifier = "mobile";
// query parameter name
export const SELECTED_TAB_SEARCH_QUERY_PARAM_NAME = "selectedTab";
export const PRAJAVANI_INVALID_EMAIL_MSG = "ಅಮಾನ್ಯ ಇಮೇಲ್ ಐಡಿ";
export const PRAJAVANI_INVALID_PHONE_NUMBER_MSG = "ಮೊಬೈಲ್ ನಂಬರ್ ಮಾನ್ಯವಲ್ಲ";
// eslint-disable-next-line no-useless-escape
export const EMAIL_REGEX =
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.(?:com|org|net|edu|gov|mil|biz|info|name|pro|aero|coop|int|arpa|[a-zA-Z]{2}))$/;
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*\.(?:com|org|net|edu|gov|mil|biz|info|name|pro|aero|coop|int|arpa|[a-zA-Z]{2})$/;

export const PHONE_NUMBER_REGEX = /^[6-9]\d{9}$/;
export const PHONE_NUMBER = "phoneNumber";
export const SCOPE_FOR_SIGNLE_TAP_GOOGLE =
  "https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/user.gender.read https://www.googleapis.com/auth/user.birthday.read";

export const __INTERNAL_APP_NAME__DECCAN = "Deccan";
export const __INTERNAL_APP_NAME__PRAJAVANI = "Prajavani";

export const NORMALIZE_URL_REGEX = /(https?:\/\/)?(www\.)?/; // Remove protocol part (http:// or https://) and optional www.
export const DOMAIN_CAPTURING_GROUP_REGEX = /^[^/]+/; // This regex matches everything up to the first /
